import React from "react";
import { Layout, HomeCom } from "../components";

const Home = () => {
  return (
    <>
      <Layout>
        <HomeCom />
      </Layout>
    </>
  );
};

export default Home;
